module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgd2lkdGg9IjUwcHgiIGhlaWdodD0iNTBweCIgdmlld0JveD0iMCAwIDUwIDUwIj4NCgk8Y2lyY2xlIGN4PSIxNy44MiIgY3k9IjE4LjExIiByPSIxNi4yMSIvPg0KCTxsaW5lIHgxPSIyOS4yOCIgeTE9IjI5LjU3IiB4Mj0iNDguMjEiIHkyPSI0OC41Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/stroke/search.svg
// module id = ./node_modules/graphcool-styles/icons/stroke/search.svg
// module chunks = 0 1